import {
  Component,
  HostListener,
  Inject,
  Input,
  NgZone,
  OnInit,
  PLATFORM_ID,
  Sanitizer,
  SecurityContext,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { AccessibiltyComponent } from "./accessibilty/accessibilty.component";
import { DeviceDetectorService } from "ngx-device-detector";
import { MatIconModule } from "@angular/material/icon";
import { CookieService } from "ngx-cookie-service";
import { filter, interval, Subscription } from "rxjs";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { environment } from "../../../../environments/environment";
import {
  scrollToFragmentId,
  highlightTextOnPage,
} from "../../../core/utils/fragment.util";
import {
  readEntirePage,
  resetHeaderSpokenState,
} from "../../../core/utils/speech-utils";
import { EventEmitterService } from "../../../Services/Common/event-emitter.service";
import { HighlightPipe } from "../../../Pipes/highlight.pipe";
import { HttpService } from "../../../Services/http";
import { AlertService } from "../../../Services/notifications/alert.service";
import { AuthService, TokenService } from "../../../Services/auth";
import { EncryptionService } from "../../../Services/encryption";
import { SecureStorageService } from "../../../Services/cache";
import { KeyboardService, ThemeService } from "../../../Services/platform";
import { SearchService } from "../../../Services/api";

@Component({
  selector: "app-header",
  imports: [
    CommonModule,
    MatIconModule,
    FormsModule,
    RouterModule,
    AccessibiltyComponent,
    MatDialogModule,
    HighlightPipe,
  ],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
})
export class HeaderComponent implements OnInit {
  private readonly PHONE_VIEW_BREAKPOINT = 768;
  private updateHeaderHeightTimeout: number | null = null;
  private lastHeaderHeight: number = 0;
  private lastBreadcrumbHeight: number = 0;

  headerContent: any = [];
  selectedIndex: number | null = null;
  selectedSubIndex: number | null = null;
  showSubmenu = false;
  searchInput: any = "";
  activeMenuIndex: number | null = null;
  activeSubMenuIndex: { [key: number]: number | null } = {};
  activeThirdMenuIndex: { [key: number]: { [key: number]: number | null } } =
    {};
  viewAccessibility: boolean = false;
  displaySearch: boolean = false;
  showDropdown: boolean = false;
  allItems: string[] = ["Apple", "Banana", "Cherry", "Date", "Elderberry"];
  allHeadings: any;
  allContent: any;
  filteredContent: any[] = [];
  filteredLabels: any[] = [];

  isViewMode = true;
  isDropdownOpen: boolean[] = [];
  isDarkModeEnable: boolean = false;
  isHighContrastModeEnable: boolean = false;
  currentTheme: "light" | "dark" = "light";
  isMobileNavVisible = false;
  isPhoneView = false;
  isHighContrast: boolean = false;
  @Input() searchInp!: string;
  searchText: string | undefined;
  showInput!: boolean;
  showloading: boolean = true;
  showContent: boolean = false;

  //newly added
  loggedUser = false;
  profileConfig: any;
  // object URL created from fetched avatar blob
  avatarObjUrl: string | null = null;
  private avatarObjectUrlRevokable: string | null = null;
  // keep the original (uncompressed) avatar URL to open full-size when needed
  originalAvatarUrl: string | null = null;
  userId: any;
  isDropdownVisible = false;
  apps: any[] = [];
  isAppPanelVisible: boolean = false;
  selectedPath: string = "/";
  countdown: string = "";
  showSessionTimer = false;
  remainingTime!: number | null;
  // Wall-clock expiry timestamp (ms since epoch) used to keep countdown accurate when tab is backgrounded
  private remainingTimeEnd: number | null = null;
  private localTickSub?: Subscription;
  headerValues: any = [];
  searchLoading: boolean = false;
  allLabelsFlat: any[] = [];
  allContentFlat: any[] = [];
  private boundOnDocumentClick: any;

  private routerEventsSubscription?: Subscription;
  private authSubscription?: Subscription;
  private themeSubscription?: Subscription;
  private highContrastSubscription?: Subscription;
  private dialogOpenSub?: Subscription;
  private dialogCloseSub?: Subscription;
  private searchSubscription?: Subscription;
  private mfaVerifiedSub?: Subscription;

  private inactivityTimer: any;
  private lastActivityTime!: number;
  private SESSION_COUNTDOWN = 20 * 60 * 1000; // 20 minute session countdown
  private readonly SESSION_WARNING_THRESHOLD = 5 * 60 * 1000; // Show warning at last 5 minute
  private dialogRef: any;
  private hasShownSessionWarning = false;
  private boundOnUserActivity: (() => void) | null = null;
  private boundOnResize: any;
  private boundOnVisibilityChange: any;
  // Track non-modifier key state for combos like Insert + H
  private insertPressed: boolean = false;

  // timeout used to clear a transient "insert pressed" state when tracking sequences
  private insertTimeout: number | null = null;

  private navigationHistory: string[] = [];
  private currentHistoryIndex: number = -1;
  private isNavigatingViaShortcut: boolean = false;
  private lastInteractionType: "pointer" | "keyboard" | null = null;

  constructor(
    private ngZone: NgZone,
    private httpService: HttpService,
    private alertService: AlertService,
    private authService: AuthService,
    private dialog: MatDialog,
    private secureStorage: SecureStorageService,
    private tokenService: TokenService,
    private encryptionService: EncryptionService,
    private sanitizer: DomSanitizer,
    private themeService: ThemeService,
    private device: DeviceDetectorService,
    private router: Router,
    private searchService: SearchService,
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private keyboardService: KeyboardService,
    private bus: EventEmitterService,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      window.speechSynthesis.cancel();
    }
    this.authSubscription = this.authService.loggedIn$.subscribe(
      (isLoggedIn) => {
        // console.log('HeaderComponent - Auth state changed. IsLoggedIn:', isLoggedIn);
        this.loggedUser = isLoggedIn;
      },
    );
  }

  // Fetch an avatar image and create an object URL so the browser performs the network request
  async loadAvatarFromPhoto(photoSrc?: string | null): Promise<void> {
    try {
      // Prefer explicitly provided photoSrc
      let src = photoSrc || null;
      if (!src && this.profileConfig && this.profileConfig.user) {
        src =
          this.profileConfig.user.photo ||
          this.profileConfig.user.photoUrl ||
          this.profileConfig.user.avatar ||
          null;
      }
      if (!src) {
        this.avatarObjUrl = "./assets/Images/default-avatar.png";
        return;
      }

      // Normalize relative path to absolute backend API base
      if (!/^https?:\/\//i.test(src)) {
        const apiBase = (environment.apiUrl || "").replace(/\/$/, "");
        src = apiBase + src;
      }

      // remember the original absolute URL (so we can open full-size later)
      this.originalAvatarUrl = src;

      // fetch the image as a blob so we can create an object URL (forces network call)
      const resp = await fetch(src, { method: "GET", credentials: "include" });
      if (!resp.ok) throw new Error(`Failed to fetch avatar: ${resp.status}`);
      const blob = await resp.blob();

      // revoke previous object URL if present
      try {
        if (this.avatarObjectUrlRevokable) {
          URL.revokeObjectURL(this.avatarObjectUrlRevokable);
          this.avatarObjectUrlRevokable = null;
        }
      } catch (e) {
        /* ignore */
      }

      // If the image is large, compress it for header display to save bandwidth and memory
      let useBlob: Blob = blob;
      try {
        const LARGE_THRESHOLD = 150 * 1024; // 150KB
        if (blob.size > LARGE_THRESHOLD && typeof document !== "undefined") {
          try {
            const compressed = await this.compressImageBlob(
              blob,
              300,
              300,
              0.75,
            );
            if (compressed && compressed.size > 0) {
              useBlob = compressed;
            }
          } catch (e) {
            // if compression fails, fall back to original blob
            console.warn("Avatar compression failed, using original image", e);
            useBlob = blob;
          }
        }
      } catch (e) {
        // ignore
      }

      const objectUrl = URL.createObjectURL(useBlob);
      this.avatarObjectUrlRevokable = objectUrl;
      // this.avatarObjUrl = './assets/Images/news1.jpg';
      this.avatarObjUrl = objectUrl;
      return;
    } catch (err) {
      console.warn("loadAvatarFromPhoto failed:", err);
      this.avatarObjUrl = "./assets/Images/default-avatar.png";
      return;
    }
  }

  /**
   * Compress an image blob using a canvas. Returns a new Blob.
   */
  private compressImageBlob(
    blob: Blob,
    maxWidth = 300,
    maxHeight = 300,
    quality = 0.8,
  ): Promise<Blob> {
    return new Promise((resolve, reject) => {
      try {
        const url = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
          try {
            let { width, height } = img;
            // calculate new size preserving aspect ratio
            const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
            const newW = Math.floor(width * ratio);
            const newH = Math.floor(height * ratio);
            const canvas = document.createElement("canvas");
            canvas.width = newW;
            canvas.height = newH;
            const ctx = canvas.getContext("2d");
            if (!ctx) {
              URL.revokeObjectURL(url);
              return reject(new Error("Canvas context not available"));
            }
            ctx.drawImage(img, 0, 0, newW, newH);
            canvas.toBlob(
              (b) => {
                URL.revokeObjectURL(url);
                if (b) return resolve(b);
                return reject(new Error("Canvas toBlob returned null"));
              },
              "image/jpeg",
              quality,
            );
          } catch (e) {
            URL.revokeObjectURL(url);
            return reject(e);
          }
        };
        img.onerror = (ev) => {
          URL.revokeObjectURL(url);
          reject(new Error("Failed to load image for compression"));
        };
        img.src = url;
      } catch (e) {
        reject(e);
      }
    });
  }

  openFullAvatar(event?: MouseEvent): void {
    try {
      if (event) event.stopPropagation();
      const url =
        this.originalAvatarUrl ||
        (this.profileConfig &&
          (this.profileConfig.user?.avatar ||
            this.profileConfig.user?.photo ||
            this.profileConfig.user?.photoUrl));
      if (!url) return;
      window.open(url, "_blank");
    } catch (e) {
      /* ignore */
    }
  }

  onAvatarError(event: any): void {
    try {
      const img =
        event && event.target ? (event.target as HTMLImageElement) : null;
      if (!img) return;
      if (img.complete && img.naturalWidth && img.naturalWidth > 0) return;
      const currentSrc = (img.src || "").toString();
      if (currentSrc.includes("default-avatar.png")) return;
      console.warn(
        "Avatar image failed to load, applying fallback. src=",
        currentSrc,
        "event=",
        event,
      );
      img.src = "./assets/Images/default-avatar.png";
    } catch (e) {
      /* ignore */
    }
  }

  onAvatarLoad(event: any): void {
    try {
      const img =
        event && event.target ? (event.target as HTMLImageElement) : null;
      if (!img) return;
      if (!img.src.includes("default-avatar.png")) {
        console.log("Avatar loaded successfully:", img.src);
      }
    } catch (e) {
      /* ignore */
    }
  }

  async ngOnInit() {
    this.userId = "";
    this.authSubscription = this.authService.loggedIn$.subscribe(
      (isLoggedIn) => {
        // console.log('HeaderComponent - Auth state changed. IsLoggedIn:', isLoggedIn);
        this.loggedUser = isLoggedIn;
        this.allHeadings = null;
        this.allContent = null;
        this.filteredLabels = [];
        this.filteredContent = [];

        if (isLoggedIn) {
          this.loadApps();
          this.userId = this.authService.getCurrentUserId();
          const userProfile = this.tokenService.getUserProfile();
          if (userProfile) {
            this.profileConfig = {
              user: userProfile,
              title: "Profile",
            };
            // Debug: log profile config to ensure avatar URL is present
            try {
              console.log("Header - profileConfig set:", this.profileConfig);
            } catch (e) {}
            try {
              // Kick off fetch-based avatar load so the browser requests the photo URL
              this.loadAvatarFromPhoto(
                this.profileConfig?.user?.avatar ||
                  this.profileConfig?.user?.photo ||
                  this.profileConfig?.user?.photoUrl,
              );
            } catch (e) {
              /* ignore */
            }
          }
          this.scheduleHeaderHeightUpdate();
          // Refresh header nav so role-based filters are applied after login
          try {
            this.getData();
          } catch (e) {
            /* ignore */
          }
        } else {
          this.userId = null;
          this.profileConfig = null;
          this.stopSessionCountdown();
          this.stopInactivityTracking();
          this.scheduleHeaderHeightUpdate();
          // Refresh header nav on logout as well
          try {
            this.getData();
          } catch (e) {
            /* ignore */
          }
        }
      },
    );

    // Start inactivity/session tracking only after full MFA-verified login (or restored session).
    this.mfaVerifiedSub = this.authService.mfaVerified$.subscribe(
      (verified) => {
        if (verified) {
          const userId = this.tokenService.getUserId();
          if (userId) {
            this.authService.checkSessionValidity(userId).subscribe({
              next: (resp: any) => {
                try {
                  const remainingSessionTime = resp?.response?.user?.sessionTimer;
                  if (remainingSessionTime) {
                    this.tokenService.updateSessionTimer(remainingSessionTime);
                    console.log('Updated session timer from server on reload:', remainingSessionTime);
                  }
                } catch (error) {
                  console.warn('Error updating session timer on reload:', error);
                }
                this.startInactivityTracking();
              },
              error: (err) => {
                console.error('Failed to check session validity on reload:', err);
                this.startInactivityTracking();
              },
            });
          } else {
            this.startInactivityTracking();
          }
        }
      },
    );

    const existingUserId = this.secureStorage.get<string>("userId", true);
    if (existingUserId && !this.authService.isLoggedIn()) {
      this.authService.refreshAuthState();
    }
    this.selectedPath = this.normalizeRoutePath(this.router.url);
    this.navigationHistory.push(this.normalizeRoutePath(this.router.url));
    this.currentHistoryIndex = 0;
    this.routerEventsSubscription = this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event) => {
        this.selectedPath = this.normalizeRoutePath(
          event.urlAfterRedirects ?? event.url,
        );
        this.scheduleHeaderHeightUpdate();
        // Close any open dialog when navigation happens to avoid dialogs persisting across pages
        try {
          if (
            this.dialog &&
            this.dialog.openDialogs &&
            this.dialog.openDialogs.length
          ) {
            this.dialog.closeAll();
          }
        } catch (e) {
          console.warn(
            "Error while attempting to close dialogs on navigation",
            e,
          );
        }
        const url = this.normalizeRoutePath(
          event.urlAfterRedirects ?? event.url,
        );
        // console.log('NavigationEnd:', url, 'history before:', this.navigationHistory, 'isShortcut:', this.isNavigatingViaShortcut);
        if (
          !this.isNavigatingViaShortcut &&
          this.navigationHistory[this.navigationHistory.length - 1] !== url
        ) {
          this.navigationHistory.push(url);
          this.currentHistoryIndex = this.navigationHistory.length - 1;
          // console.log('Pushed to history, new history:', this.navigationHistory, 'index:', this.currentHistoryIndex);
        }
      });
    if (typeof window !== "undefined") {
      this.showInput = window.innerWidth >= 900;
      this.updateResponsiveState();
    }
    if (isPlatformBrowser(this.platformId) && window.localStorage) {
      this.themeSubscription = this.themeService.theme$.subscribe((theme) => {
        this.currentTheme = theme as "light" | "dark";
        this.isDarkModeEnable = theme === "dark";
      });

      this.highContrastSubscription =
        this.themeService.isHighContrast$.subscribe((isHigh) => {
          this.isHighContrastModeEnable = !!isHigh;
        });
    }
    this.searchText = this.searchInp;

    if (isPlatformBrowser(this.platformId)) {
      this.checkNavbarOverflow();
      this.setDefaultZoom();
      this.boundOnResize = this.onResize.bind(this);
      window.addEventListener("resize", this.boundOnResize);
      this.boundOnDocumentClick = this.onDocumentClick.bind(this);
      document.addEventListener("click", this.boundOnDocumentClick, true);
    }

    try {
      this.dialogOpenSub = this.dialog.afterOpened.subscribe(() => {
        try {
          document.body.classList.add("dialog-open");
        } catch (e) {}
        try {
          this.setMenuInert(true);
        } catch (e) {}
      });
      this.dialogCloseSub = this.dialog.afterAllClosed.subscribe(() => {
        try {
          document.body.classList.remove("dialog-open");
        } catch (e) {}
        try {
          this.setMenuInert(false);
        } catch (e) {}
      });
    } catch (e) {
      // ignore if MatDialog not available
    }
    // await this.getData();
    this.updateHeaderHeight();
    // load apps list for app switcher
    try {
      this.loadApps();
    } catch (e) {
      /* ignore */
    }

    this.searchSubscription = this.searchService.state$.subscribe((state) => {
      this.searchInput = state.searchTerm;
      this.searchText = state.searchTerm;
    });
  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.scheduleHeaderHeightUpdate();

    // Second attempt after a short delay to handle deferred content
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.scheduleHeaderHeightUpdate();
        });
      }, 200);
    });
  }

  @HostListener("document:mousedown")
  markPointerInteraction(): void {
    this.lastInteractionType = "pointer";
  }

  @HostListener("document:touchstart")
  markTouchInteraction(): void {
    this.lastInteractionType = "pointer";
  }

  @HostListener("document:keydown", ["$event"])
  markKeyboardInteraction(_event: KeyboardEvent): void {
    this.lastInteractionType = "keyboard";
  }

  private setMenuInert(inert: boolean) {
    try {
      const menu = document.querySelector(".menu") as HTMLElement | null;
      if (!menu) return;
      if (inert) {
        menu.setAttribute("aria-hidden", "true");
        // mark focusable elements so we can restore them later
        const focusables = menu.querySelectorAll<HTMLElement>(
          "a, button, input, [tabindex]",
        );
        focusables.forEach((el, idx) => {
          const prev = el.getAttribute("data-prev-tabindex");
          if (prev === null) {
            const currentTab = el.getAttribute("tabindex");
            el.setAttribute("data-prev-tabindex", currentTab ?? "");
          }
          el.setAttribute("tabindex", "-1");
        });
      } else {
        menu.removeAttribute("aria-hidden");
        const focusables = menu.querySelectorAll<HTMLElement>(
          "a, button, input, [data-prev-tabindex]",
        );
        focusables.forEach((el) => {
          const prev = el.getAttribute("data-prev-tabindex");
          if (prev === "") {
            el.removeAttribute("tabindex");
          } else if (prev !== null) {
            el.setAttribute("tabindex", prev);
          }
          el.removeAttribute("data-prev-tabindex");
        });
      }
    } catch (e) {
      // ignore DOM errors
    }
  }

  ngOnDestroy(): void {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      if (this.boundOnResize) {
        window.removeEventListener("resize", this.boundOnResize);
      }
      if (this.boundOnDocumentClick) {
        document.removeEventListener("click", this.boundOnDocumentClick, true);
      }
    }
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    this.stopSessionCountdown();
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
    if (this.themeSubscription) this.themeSubscription.unsubscribe();
    if (this.highContrastSubscription)
      this.highContrastSubscription.unsubscribe();
    if (this.dialogOpenSub) this.dialogOpenSub.unsubscribe();
    if (this.dialogCloseSub) this.dialogCloseSub.unsubscribe();
    if (this.mfaVerifiedSub) this.mfaVerifiedSub.unsubscribe();
    this.stopInactivityTracking();
  }

  async searchPrediction(event: any) {
    const raw = (event?.target?.value ?? "").toString();
    const input = raw;
    const sanitized =
      this.sanitizer.sanitize(SecurityContext.HTML, input) || "";
    this.searchText = input;
    this.searchInput = sanitized;

    const trimmedForSearch = (this.searchInput || "").trim();
    if (trimmedForSearch.length > 2) {
      this.searchLoading = true;
      this.showDropdown = true;

      try {
        await this.getSearchContent();

        try {
          const labels =
            this.allLabelsFlat && this.allLabelsFlat.length
              ? this.allLabelsFlat
              : this.searchLabels();
          this.filteredLabels = Array.isArray(labels)
            ? labels
                .filter((l) =>
                  (l.label || "")
                    .toLowerCase()
                    .includes(this.searchInput.toLowerCase()),
                )
                .slice(0, 6)
            : [];
        } catch (e) {
          this.filteredLabels = [];
        }

        // console.log('Filtered Labels:', this.filteredLabels, this.filteredContent);

        try {
          const contentMatches = await this.filterJsonBySearchText();
          if (Array.isArray(contentMatches) && contentMatches.length) {
            this.filteredContent = contentMatches.slice(0, 5);
          } else if (this.allContentFlat && this.allContentFlat.length) {
            const q = this.searchInput.toLowerCase();
            const matches = this.allContentFlat
              .filter((c: any) => {
                const txt =
                  (c.section || "") +
                  " " +
                  (c.tab || "") +
                  " " +
                  JSON.stringify(c.components || c.content || "");
                return txt.toLowerCase().includes(q);
              })
              .map((c: any) => ({
                route: c.route,
                match: c.section || c.tab || c.route,
              }));
            this.filteredContent = matches.slice(0, 5);
          } else {
            this.filteredContent = [];
          }
        } catch (e) {
          this.filteredContent = [];
        }
      } catch (error) {
        console.error("Search error:", error);
        this.filteredLabels = [];
        this.filteredContent = [];
      } finally {
        this.searchLoading = false;
      }
    } else {
      this.showDropdown = false;
      this.searchLoading = false;
    }

    if (
      (event?.code || "").toString().toLowerCase() === "enter" ||
      (event?.key || "").toString().toLowerCase() === "enter"
    ) {
      this.searchInput = (this.searchInput || "").trim();
      this.routeToSearch();
    }
  }

  private async getSearchContent(): Promise<void> {
    if (
      this.allHeadings &&
      this.allContent &&
      Object.keys(this.allContent).length
    )
      return;

    const env: any = environment as any;
    const urls = new Set<string>();

    Object.keys(env).forEach((k) => {
      // skip large or special config keys we don't want to fetch here
      if (!k) return;
      const kk = String(k).toLowerCase();
      if (
        kk === "signup" ||
        kk === "mainnav" ||
        kk === "production" ||
        kk === "secretkey"
      )
        return;
      const v = env[k];
      if (typeof v === "string") {
        const lower = v.toLowerCase();
        if (
          lower.endsWith(".json") ||
          lower.includes(".json?") ||
          lower.includes(".json/")
        ) {
          urls.add(v);
        }
      }
    });

    this.allHeadings = this.allHeadings || { values: [] };
    this.allContent = this.allContent || {};

    const fetches = Array.from(urls).map(async (url) => {
      try {
        const resp = await this.httpService.getJsonData(url, "");
        return { url, resp };
      } catch (e) {
        console.warn("getSearchContent: failed fetch", url, e);
        return { url, resp: null };
      }
    });

    try {
      const results = await Promise.all(fetches);

      // Determine role once (prefer secure storage), normalize to lower case
      const storedRole = String(
        this.secureStorage.get<string>("user_role", true) || "",
      ).toLowerCase();
      const tokenRole = String(
        this.tokenService.getUserProfile()?.role || "",
      ).toLowerCase();
      const role = (storedRole || tokenRole || "").toLowerCase();

      results.forEach((r) => {
        const beforeKeys = new Set(Object.keys(this.allContent || {}));
        const data = r.resp;
        if (!data || !data.response) return;
        const resp = data.response;

        // Build allowed sideMenu ids based on flags (if sideMenu present)
        let allowedIds: Set<string> | null = null;
        if (Array.isArray(resp.sideMenu)) {
          allowedIds = new Set<string>();
          for (const s of resp.sideMenu) {
            try {
              if (!s) continue;
              if (s.hide === true) continue;
              const hasTeam = Object.prototype.hasOwnProperty.call(
                s,
                "teamUser",
              );
              const hasTin = Object.prototype.hasOwnProperty.call(s, "tinUser");
              let include = true;
              if (role === "teammember") {
                if (hasTeam) include = !!s.teamUser;
              } else if (role === "tin") {
                if (hasTin) include = !!s.tinUser;
              } else {
                if (hasTeam || hasTin) include = false;
              }
              if (include) {
                const id = s.contentId || s.route || "";
                if (id) allowedIds.add(String(id));
              }
            } catch (e) {
              /* ignore per-item issues */
            }
          }
        }

        // Prepare filtered menuContent (respect hide and role flags and allowedIds)
        let filteredMenuContent: any = null;
        if (resp.menuContent && typeof resp.menuContent === "object") {
          filteredMenuContent = {};
          for (const k of Object.keys(resp.menuContent)) {
            try {
              const entry = resp.menuContent[k];
              if (!entry) continue;
              if (entry.hide === true) continue;
              const hasTeam = Object.prototype.hasOwnProperty.call(
                entry,
                "teamUser",
              );
              const hasTin = Object.prototype.hasOwnProperty.call(
                entry,
                "tinUser",
              );
              let include = true;
              if (role === "teammember") {
                if (hasTeam) include = !!entry.teamUser;
              } else if (role === "tin") {
                if (hasTin) include = !!entry.tinUser;
              } else {
                if (hasTeam || hasTin) include = false;
              }
              if (!include) continue;
              if (allowedIds && !allowedIds.has(k)) continue;
              filteredMenuContent[k] = entry;
            } catch (e) {
              /* ignore per-item errors */
            }
          }
        }

        // Helper to check if a values-entry is allowed based on sideMenu allowedIds or flags
        const isValueAllowed = (v: any) => {
          try {
            if (!v) return false;
            if (v.hide === true) return false;
            const hasTeam = Object.prototype.hasOwnProperty.call(v, "teamUser");
            const hasTin = Object.prototype.hasOwnProperty.call(v, "tinUser");
            if (role === "teammember") {
              if (hasTeam) return !!v.teamUser;
            } else if (role === "tin") {
              if (hasTin) return !!v.tinUser;
            } else {
              if (hasTeam || hasTin) return false;
            }
            if (allowedIds) {
              // prefer explicit contentId, else try route's last segment
              const cid = v.contentId || "";
              if (cid && allowedIds.has(String(cid))) return true;
              const routeSeg =
                (v.route || "").toString().split("/").filter(Boolean).pop() ||
                "";
              if (routeSeg && allowedIds.has(routeSeg)) return true;
              return false;
            }
            return true;
          } catch (e) {
            return true;
          }
        };

        // Process resp.values
        if (Array.isArray(resp.values)) {
          const allowedVals = resp.values.filter((v: any) => isValueAllowed(v));
          this.allHeadings.values = this.allHeadings.values.concat(allowedVals);
          allowedVals.forEach((v: any) => {
            try {
              if (v && v.route && !this.allContent[v.route])
                this.allContent[v.route] = v;
            } catch (e) {
              /* ignore */
            }
          });
        }

        // Process resp.content (standalone content object) — include only keys allowed or without role flags
        if (resp.content && typeof resp.content === "object") {
          const entries = Object.entries(resp.content);
          for (const [k, val] of entries) {
            try {
              const item: any = val;
              if (!item) continue;
              if (item.hide === true) continue;
              const hasTeam = Object.prototype.hasOwnProperty.call(
                item,
                "teamUser",
              );
              const hasTin = Object.prototype.hasOwnProperty.call(
                item,
                "tinUser",
              );
              let include = true;
              if (role === "teammember") {
                if (hasTeam) include = !!item.teamUser;
              } else if (role === "tin") {
                if (hasTin) include = !!item.tinUser;
              } else {
                if (hasTeam || hasTin) include = false;
              }
              if (!include) continue;
              // If sideMenu exists, only include content whose key is in allowedIds
              if (allowedIds && !allowedIds.has(k)) continue;
              if (!this.allContent[k]) this.allContent[k] = item as any;
            } catch (e) {
              /* ignore */
            }
          }
        }

        // Process filtered menuContent into allContent
        if (filteredMenuContent) {
          Object.entries(filteredMenuContent).forEach(
            ([menuKey, menuVal]: any) => {
              try {
                if (Array.isArray(menuVal)) {
                  menuVal.forEach((it: any, idx: number) => {
                    const routeKey =
                      it && it.route ? it.route : `${menuKey}/${idx}`;
                    if (routeKey && !this.allContent[routeKey])
                      this.allContent[routeKey] = it;
                  });
                } else if (menuVal && typeof menuVal === "object") {
                  const innerKeys = Object.keys(menuVal || {});
                  let addedInner = false;
                  innerKeys.forEach((innerKey) => {
                    const inner = menuVal[innerKey];
                    if (
                      inner &&
                      typeof inner === "object" &&
                      (inner.components ||
                        inner.route ||
                        inner.section ||
                        inner.tab ||
                        inner.pageName)
                    ) {
                      let routeKey = inner.route || `${menuKey}/${innerKey}`;
                      if (this.allContent[routeKey]) {
                        routeKey = `${routeKey}::${innerKey}`;
                      }
                      if (routeKey && !this.allContent[routeKey]) {
                        this.allContent[routeKey] = { ...inner };
                      }
                      addedInner = true;
                    }
                  });

                  if (!addedInner) {
                    const routeKey =
                      menuVal && menuVal.route ? menuVal.route : menuKey;
                    if (routeKey && !this.allContent[routeKey])
                      this.allContent[routeKey] = menuVal;
                  }
                } else {
                  const routeKey =
                    menuVal && menuVal.route ? menuVal.route : menuKey;
                  if (routeKey && !this.allContent[routeKey])
                    this.allContent[routeKey] = menuVal;
                }
              } catch (e) {
                /* ignore */
              }
            },
          );
        }

        // Fallback: if resp has no sideMenu and no menuContent and no flags, include top-level objects
        if (
          !Array.isArray(resp.sideMenu) &&
          !resp.menuContent &&
          typeof resp === "object"
        ) {
          const hasRoleFlagAtTop = Object.keys(resp).some(
            (k) => k === "tinUser" || k === "teamUser",
          );
          if (!hasRoleFlagAtTop) {
            Object.keys(resp).forEach((k) => {
              const val = resp[k];
              if (Array.isArray(val)) {
                this.allHeadings.values = this.allHeadings.values.concat(val);
                val.forEach((v: any) => {
                  if (v && v.route && !this.allContent[v.route])
                    this.allContent[v.route] = v;
                });
              } else if (val && typeof val === "object") {
                if (!this.allContent[k]) this.allContent[k] = val;
              }
            });
          }
        }
      });

      try {
        const seen = new Set<string>();
        const unique: any[] = [];
        (this.allHeadings.values || []).forEach((h: any) => {
          const key = (h.route || "") + "||" + (h.label || "");
          if (!seen.has(key)) {
            seen.add(key);
            unique.push(h);
          }
        });
        this.allHeadings.values = unique;
      } catch (e) {}
    } catch (e) {
      console.error("getSearchContent error", e);
    }
  }

  private isExternalUrl(route: string): boolean {
    return /^(https?:|mailto:|tel:)/i.test(route);
  }

  clearText() {
    this.searchText = "";
    this.showDropdown = false;
  }

  hidePrediction() {
    this.showDropdown = false;
  }

  stopEvent(event: Event) {
    event.stopPropagation();
  }

  openAccessibility() {
    this.displaySearch = false;
    this.viewAccessibility = true;
    const accessHeader = document.querySelector(
      ".access-header",
    ) as HTMLElement | null;
    if (accessHeader && accessHeader.classList) {
      accessHeader.classList.add("active-access");
    }
    this.scheduleHeaderHeightUpdate();
  }

  closeMobileSearch() {
    this.closeSearchDropdown();
    this.scheduleHeaderHeightUpdate();
  }

  checkNavbarOverflow() {
    const wrapper = document.getElementById("zoom-wrapper");
    const navbar = document.getElementById("navbarNavDropdown");
    if (!wrapper || !navbar) {
      // console.warn('Required elements not found');
      return;
    }

    const zoomLevel = parseFloat(wrapper.style.zoom || "1");

    // Get actual rendered width of navbar
    const navbarRect = navbar.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();

    const isOverflowing = navbarRect.right > wrapperRect.right;

    this.isMobileNavVisible = isOverflowing;

    this.cookieService.delete("zoom-level");
    this.cookieService.set("zoom-level", `${zoomLevel}`, 1, "/");
  }

  getNavbarFontSize() {
    const width = typeof window != "undefined" ? window.innerWidth : 1440;
    return width > 1024 && width < 1440 ? "font-for-lower-screens" : "";
  }

  setDefaultZoom(): void {
    const wrapper = document.getElementById("zoom-wrapper");
    if (!wrapper) return;

    const zoomFromSession =
      this.secureStorage.get<string>("zoom-level", true) || null;
    let zoom = "1";

    if (zoomFromSession) {
      if (window.innerWidth < 1440 && zoomFromSession === "1") {
        zoom = "0.75";
      } else if (window.innerWidth > 1500 && zoomFromSession === "1") {
        zoom = "1.15";
      } else {
        zoom = zoomFromSession;
      }
    } else if (window.innerWidth < 1440 && window.innerWidth > 1100) {
      zoom = "0.75";
    } else if (window.innerWidth > 1500) {
      zoom = "1.15";
    }

    wrapper.style.zoom = zoom;
    // console.log("zoom set to", zoom);
  }

  hideAccessibility() {
    this.viewAccessibility = false;
    this.scheduleHeaderHeightUpdate();
  }

  openMobileAccessibility(event?: Event): void {
    event?.stopPropagation();
    this.isDropdownVisible = false;
    this.openAccessibility();
  }

  search(loc: string) {
    // console.log(loc, window.innerWidth);

    if (window.innerWidth < 901 && loc === "main") {
      this.displaySearch = true;
      this.scheduleHeaderHeightUpdate();
      // console.log("search Input", window.innerWidth, this.displaySearch, this.searchInput);
    } else {
      // console.log("search Input", this.searchInput);
    }
  }

  searchLabels(): { route: string; label: string }[] {
    const searchLower = this.searchInput.toLowerCase();
    const result: {
      route: string;
      label: string;
      label_route: string;
      tax_type: string;
      parent: string;
    }[] = [];

    const traverse = (items: any[], parent_label: string) => {
      // console.log("Items to traverse", items, parent_label);
      items.forEach((item) => {
        if (item.label && typeof item.label === "string") {
          if (searchLower && item.label.toLowerCase().includes(searchLower)) {
            let path = item.route?.split("/");
            let route_label = path ? path[0] || path[1] : "";

            // Replace hyphens with spaces and capitalize each word
            let formatted_label_route = route_label
              .replace(/-/g, " ")
              .split(" ")
              .map(
                (word: string) => word.charAt(0).toUpperCase() + word.slice(1),
              )
              .join(" ");

            result.push({
              route: item.route || "",
              label: item.label,
              label_route: formatted_label_route,
              tax_type: item.tax_type || "",
              parent: parent_label || "",
            });
          }
        }

        // if (Array.isArray(item.subitems)) {
        //   traverse(item.subitems, item.label);
        // }
      });
    };
    // console.log("All Headings", this.allHeadings, result);
    this.allHeadings?.values.forEach((ele: any) => {
      traverse(ele.subitems, ele.label);
    });
    return result;
  }

  async filterJsonBySearchText() {
    const searchLower = (this.searchInput || "").toLowerCase();
    const result: any[] = [];

    const checkAndAdd = (text: any, meta: any, matchType: string) => {
      if (!text || typeof text !== "string") return;
      const plain = text.replace(/<[^>]*>/g, "");
      const lowerText = plain.toLowerCase();
      const index = lowerText.indexOf(searchLower);
      if (index === -1) return;

      const matchLength = searchLower.length;
      const start = Math.max(0, index - 40);
      const end = Math.min(plain.length, index + matchLength + 40);
      const snippet = `${start > 0 ? "..." : ""}${plain.substring(start, index)}<strong>${plain.substring(index, index + matchLength)}</strong>${plain.substring(index + matchLength, end)}${end < plain.length ? "..." : ""}`;

      const entry = { ...meta, match: snippet, type: matchType };
      if (matchType === "accordion") {
        try {
          console.debug("search: accordion match", entry.route, snippet);
        } catch (e) {}
      }
      result.push(entry);
    };

    Object.entries(this.allContent || {}).forEach(
      ([key, content]: [string, any]) => {
        const meta = {
          route: content?.route || key,
          section: content?.section || content?.pageName || "",
          tab: content?.tab || "",
          tax_type: content?.tax_type,
        };

        try {
          // Titles/Headings
          checkAndAdd(content?.pageName, meta, "title");
          checkAndAdd(content?.title, meta, "title");
          checkAndAdd(content?.section, meta, "title");

          // Accordians (strings or objects)
          if (Array.isArray(content?.accordians)) {
            content.accordians.forEach((a: any) => {
              if (typeof a === "string") checkAndAdd(a, meta, "accordion");
              else if (a && typeof a === "object")
                checkAndAdd(a.title || a.heading || a.label, meta, "accordion");
            });
          }

          // Components: only inspect header, title, paragraphs, tableHeadings and buttons
          (content?.components || []).forEach((element: any) => {
            // element may be a grouping which contains component entries
            const compList = element?.components || [];
            compList.forEach((dataObj: any) => {
              // If the component itself has a header/title (sometimes accordions store header here)
              if (dataObj) {
                checkAndAdd(dataObj?.header, meta, "heading");
                checkAndAdd(dataObj?.title, meta, "title");
              }

              // If this is an accordion component, its headings often live in dataObj.data[*].header
              if (
                dataObj?.type === "accordion" ||
                Array.isArray(dataObj?.data)
              ) {
                (dataObj?.data || []).forEach((contentItem: any) => {
                  checkAndAdd(contentItem?.header, meta, "heading");
                  checkAndAdd(contentItem?.title, meta, "title");

                  // paragraphs
                  const paras =
                    contentItem?.paragraph ||
                    contentItem?.paragraphs ||
                    contentItem?.paragraphText;
                  if (typeof paras === "string")
                    checkAndAdd(paras, meta, "paragraph");
                  if (Array.isArray(paras))
                    paras.forEach(
                      (p: any) =>
                        typeof p === "string" &&
                        checkAndAdd(p, meta, "paragraph"),
                    );

                  // tableHeadings
                  const th =
                    contentItem?.tableHeadings || contentItem?.tableHeading;
                  if (typeof th === "string")
                    checkAndAdd(th, meta, "tableHeading");
                  if (Array.isArray(th))
                    th.forEach(
                      (t: any) =>
                        typeof t === "string" &&
                        checkAndAdd(t, meta, "tableHeading"),
                    );

                  // buttons
                  const btns =
                    contentItem?.buttons ||
                    contentItem?.button ||
                    contentItem?.cta ||
                    contentItem?.actions;
                  if (typeof btns === "string")
                    checkAndAdd(btns, meta, "button");
                  if (Array.isArray(btns)) {
                    btns.forEach((b: any) => {
                      if (typeof b === "string") checkAndAdd(b, meta, "button");
                      else if (b && typeof b === "object")
                        checkAndAdd(
                          b.label || b.text || b.title,
                          meta,
                          "button",
                        );
                    });
                  }
                });
              }

              // Additionally, some components embed list items with content (e.g., listItem -> content -> text)
              if (dataObj?.listItem && Array.isArray(dataObj.listItem)) {
                dataObj.listItem.forEach((li: any) => {
                  li?.content?.forEach((c: any) =>
                    checkAndAdd(c?.text, meta, "paragraph"),
                  );
                  if (li?.nestedList?.listItem)
                    li.nestedList.listItem.forEach((n: any) =>
                      n?.content?.forEach((c: any) =>
                        checkAndAdd(c?.text, meta, "paragraph"),
                      ),
                    );
                });
              }
            });
          });
        } catch (e) {
          // ignore per-item errors
        }
      },
    );

    // Deduplicate results by route + plain-text match and prefer more meaningful match types
    const priority: Record<string, number> = {
      title: 6,
      heading: 5,
      tableHeading: 4,
      paragraph: 3,
      button: 2,
      accordion: 1,
      information: 0,
    };

    const map = new Map<string, any>();
    result.forEach((r) => {
      try {
        const route = r.route || "";
        const plainMatch = (r.match || "").replace(/<[^>]*>/g, "").trim();
        const key = `${route}::${plainMatch}`;
        const current = map.get(key);
        const rType = (r.type || "information").toString();
        const rPr = priority[rType] ?? 0;
        if (!current) {
          map.set(key, r);
        } else {
          const curType = (current.type || "information").toString();
          const curPr = priority[curType] ?? 0;
          if (rPr > curPr) {
            map.set(key, r);
          }
        }
      } catch (e) {
        // keep going
      }
    });

    return Array.from(map.values());
  }

  @HostListener("window:resize")
  onResize() {
    // Show full search box on widths >= 900px; only icon for smaller than 900px
    this.showInput = window.innerWidth >= 900;
    this.updateResponsiveState();
    if (window.innerWidth >= 900) {
      this.displaySearch = false;
    }
    this.checkNavbarOverflow();
    this.setDefaultZoom();
    // Ensure header height is recalculated when the window resizes
    try {
      this.scheduleHeaderHeightUpdate();
    } catch (e) {}
  }

  async routeToSearch() {
    this.showDropdown = false;
    let labelList = await this.searchLabels();
    let contentList = await this.filterJsonBySearchText();

    this.searchService.updateState({
      searchTerm: this.searchInput,
      labelList: labelList,
      contentList: contentList,
    });
    this.router.navigate(["/search"], {
      state: {
        labels: labelList,
        content: contentList,
        searchParam: this.searchInput,
      },
    });
  }

  routeToHome() {
    // this.progress.setViewMode(false);
    this.router.navigate(["/"]);
  }

  formatTime(seconds: number | null): string {
    if (!seconds || seconds <= 0) return "00:00";
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  }

  getRouterLink(route: string): string {
    if (route && route.includes("?")) {
      return route.split("?")[0];
    }
    return route;
  }

  private updateHeaderHeight() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // console.log('Updating header height...');
    // Clear any existing timeout to debounce rapid calls
    if (this.updateHeaderHeightTimeout) {
      clearTimeout(this.updateHeaderHeightTimeout);
    }

    this.updateHeaderHeightTimeout = window.setTimeout(() => {
      // Direct DOM operations without additional timeouts for better performance
      const header = document.getElementById(
        "otb-header",
      ) as HTMLElement | null;
      let headerHeight = 0;
      let breadcrumbHeight = 0;

      if (header) {
        headerHeight = header.offsetHeight - 1;
      }

      const breadcrumb = document.querySelector(
        ".breadcrumb-ul",
      ) as HTMLElement | null;
      if (breadcrumb) {
        breadcrumbHeight = breadcrumb.offsetHeight;
      } else {
        breadcrumbHeight = 52; // Default breadcrumb height if not present
      }
      // Only update CSS variables if values have changed (caching optimization)
      if (
        headerHeight !== this.lastHeaderHeight ||
        breadcrumbHeight !== this.lastBreadcrumbHeight
      ) {
        document.documentElement.style.setProperty(
          "--header-height",
          `${headerHeight}px`,
        );
        document.documentElement.style.setProperty(
          "--breadcrumb-height",
          `${breadcrumbHeight}px`,
        );
        document.documentElement.style.setProperty(
          "--layout-margin-top",
          `${headerHeight + breadcrumbHeight}px`,
        );

        this.lastHeaderHeight = headerHeight;
        this.lastBreadcrumbHeight = breadcrumbHeight;
      }

      this.updateHeaderHeightTimeout = null;
    }, 0); // 30ms debounce for fast but smooth updates
  }

  private startSessionCountdown(): void {
    this.stopSessionCountdown();
    const sessionCountDown = this.tokenService.getSessionTimer();
    if (sessionCountDown) {
      this.tokenService.updateSessionTimer(sessionCountDown);
      this.SESSION_COUNTDOWN = this.parseTimeStringToMs(sessionCountDown);
      this.showSessionTimer = true;
      this.remainingTimeEnd = Date.now() + this.SESSION_COUNTDOWN;
      const initialRemaining = Math.max(0, this.remainingTimeEnd! - Date.now());
      this.remainingTime = initialRemaining;
      this.countdown = this.formatTimeHHMM(initialRemaining);

      // Tick every second to update the visible countdown. Use wall-clock time so the
      // countdown remains accurate even if the timer ticks are delayed while the
      // tab is backgrounded or the browser throttles timers.
      this.localTickSub = interval(1000).subscribe(() => {
        this.updateRemainingFromWallClock(false);
      });
    }
  }

  private parseTimeStringToMs(timeString: string): number {
    try {
      const parts = timeString.split(":");
      if (parts.length !== 2) {
        console.warn("Invalid time format. Expected MM:SS, got:", timeString);
        return 0;
      }

      const minutes = parseInt(parts[0], 10);
      const seconds = parseInt(parts[1], 10);

      if (isNaN(minutes) || isNaN(seconds)) {
        console.warn("Invalid time values:", { minutes, seconds });
        return 0;
      }

      // Convert to total milliseconds
      const totalSeconds = minutes * 60 + seconds;
      return totalSeconds * 1000;
    } catch (error) {
      console.warn("Error parsing time string:", error);
      return 0;
    }
  }

  private stopSessionCountdown(): void {
    if (this.localTickSub) {
      this.localTickSub.unsubscribe();
      this.localTickSub = undefined;
    }
    this.remainingTimeEnd = null;
    this.showSessionTimer = false;
    this.countdown = "";
    this.remainingTime = null;
  }

  private updateRemainingFromWallClock(forceShowWarning: boolean): void {
    if (this.remainingTimeEnd === null) return;
    const remaining = Math.max(0, this.remainingTimeEnd - Date.now());
    this.remainingTime = remaining;
    this.countdown = this.formatTimeHHMM(remaining);
    if (remaining <= 0) {
      let userId = this.tokenService.getUserId();
      this.authService.checkSessionValidity(userId).subscribe({
        next: (resp: any) => {
          try {
            const remainingSessionTime = resp?.response?.user?.sessionTimer;
            let remainingMs = this.parseTimeStringToMs(remainingSessionTime);
            if (remainingMs <= 0) {
              // Session has expired
              console.warn("Session expired according to server");
              this.clearSessionAndReload();
              return;
            } else {
              // Session is still valid
              this.tokenService.updateSessionTimer(remainingSessionTime);
              console.log("Session is still valid");
              this.SESSION_COUNTDOWN =
                this.parseTimeStringToMs(remainingSessionTime);
              this.showSessionTimer = true;
              this.remainingTimeEnd = Date.now() + this.SESSION_COUNTDOWN;
              const initialRemaining = Math.max(
                0,
                this.remainingTimeEnd! - Date.now(),
              );
              this.remainingTime = initialRemaining;
              this.countdown = this.formatTimeHHMM(initialRemaining);

              // Tick every second to update the visible countdown. Use wall-clock time so the
              // countdown remains accurate even if the timer ticks are delayed while the
              // tab is backgrounded or the browser throttles timers.
            }
          } catch (error) {
            console.warn("Error parsing session validity response:", error);
          }
        },
        error: (err) => {
          console.error("Session validity check failed:", err);
        },
      });

      if (this.dialogRef) {
        try {
          this.dialogRef.close("expired");
        } catch (e) {}
        this.dialogRef = null;
      }
      this.clearSessionAndReload();
      return;
    }

    if (
      remaining <= this.SESSION_WARNING_THRESHOLD &&
      !this.dialogRef &&
      !this.hasShownSessionWarning
    ) {
      if (
        typeof document !== "undefined" &&
        document.hidden &&
        !forceShowWarning
      ) {
        this.hasShownSessionWarning = true;
      } else {
        this.hasShownSessionWarning = true;
        this.showSessionWarning();
      }
    }
  }

  private onVisibilityChange(): void {
    try {
      this.updateRemainingFromWallClock(true);
      if (typeof document !== "undefined" && !document.hidden) {
        if (
          this.remainingTime !== null &&
          this.remainingTime <= this.SESSION_WARNING_THRESHOLD &&
          !this.dialogRef
        ) {
          if (this.hasShownSessionWarning) {
            this.showSessionWarning();
          }
        }
      }
    } catch (e) {
      // ignore
    }
  }

  formatTimeHHMM(ms: number): string {
    if (ms === null || ms === undefined) return "00:00";
    const totalSeconds = Math.max(0, Math.ceil(ms / 1000));

    // If 1 hour or more, show HH:MM:SS
    if (totalSeconds >= 3600) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${this.format(hours)}:${this.format(minutes)}:${this.format(seconds)}`;
    }

    // Otherwise show MM:SS
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${this.format(minutes)}:${this.format(seconds)}`;
  }

  format(num: number): string {
    return num < 10 ? "0" + num : num.toString();
  }

  startInactivityTracking(): void {
    this.lastActivityTime = Date.now();
    this.hasShownSessionWarning = false;

    // Store bound reference so we can remove the listener later
    this.boundOnUserActivity = this.onUserActivity.bind(this);

    // if (typeof window !== "undefined") {
    //   window.addEventListener("mousemove", this.boundOnUserActivity);
    //   window.addEventListener("keydown", this.boundOnUserActivity);
    //   window.addEventListener("click", this.boundOnUserActivity);
    //   window.addEventListener("scroll", this.boundOnUserActivity);
    //   window.addEventListener("touchstart", this.boundOnUserActivity);
    // }

    if (typeof document !== "undefined") {
      this.boundOnVisibilityChange = this.onVisibilityChange.bind(this);
      document.addEventListener(
        "visibilitychange",
        this.boundOnVisibilityChange,
      );
    }

    // Start the session countdown immediately (always visible)
    this.startSessionCountdown();
  }

  /**
   * Called on every user interaction (mousemove, keydown, click, scroll, touchstart).
   * Resets the session countdown timer back to 20 minutes.
   */
  private onUserActivity(): void {
    this.lastActivityTime = Date.now();

    // Don't reset while the warning dialog is open
    if (this.dialogRef) {
      return;
    }
    if (this.hasShownSessionWarning) {
      return;
    }

    // Throttle: skip reset if less than 2 seconds have elapsed on the countdown
    // to avoid excessive subscription churn on frequent events like mousemove
    if (this.remainingTimeEnd !== null) {
      const remaining = this.remainingTimeEnd - Date.now();
      if (remaining > this.SESSION_COUNTDOWN - 2000) {
        return;
      }
    }

    // Reset the countdown back to full 20 minutes on any activity
    this.hasShownSessionWarning = false;
    this.startSessionCountdown();
  }

  /**
   * Schedule the inactivity check after INACTIVITY_LIMIT of no activity.
   */
  private scheduleInactivityCheck(): void {
    // No longer needed — timer is always running
  }

  showSessionWarning(): void {
    let userId = this.tokenService.getUserId();
    let timer;

    this.authService.checkSessionValidity(userId).subscribe({
      next: (resp: any) => {
        try {
          const remainingSessionTime = resp?.response?.user?.sessionTimer;
          let remainingMs = this.parseTimeStringToMs(remainingSessionTime);
          if (remainingMs <= 0) {
            // Session has expired
            console.warn("Session expired according to server");
            this.clearSessionAndReload();
            return;
          }

          if (remainingMs <= this.SESSION_WARNING_THRESHOLD) {
            // Session is about to expire - show warning
            console.warn("Session time is below warning threshold");
            this.showWarningDialog(remainingSessionTime);
          } else {
            // Session is still valid
            this.tokenService.updateSessionTimer(remainingSessionTime);
            console.log("Session is still valid");
            this.SESSION_COUNTDOWN =
              this.parseTimeStringToMs(remainingSessionTime);
            this.showSessionTimer = true;
            this.remainingTimeEnd = Date.now() + this.SESSION_COUNTDOWN;
            const initialRemaining = Math.max(
              0,
              this.remainingTimeEnd! - Date.now(),
            );
            this.remainingTime = initialRemaining;
            this.countdown = this.formatTimeHHMM(initialRemaining);

            // Tick every second to update the visible countdown. Use wall-clock time so the
            // countdown remains accurate even if the timer ticks are delayed while the
            // tab is backgrounded or the browser throttles timers.
            this.localTickSub = interval(1000).subscribe(() => {
              this.updateRemainingFromWallClock(false);
            });
          }
        } catch (error) {
          console.warn("Error parsing session validity response:", error);
        }
      },
      error: (err) => {
        console.error("Session validity check failed:", err);
      },
    });
  }

  private showWarningDialog(remainingTime: number): void {
    const warningDuration = remainingTime || this.SESSION_WARNING_THRESHOLD;

    import("../session-warning-dialog/session-warning-dialog.component").then(
      (m) => {
        if (this.dialogRef) return;

        this.dialogRef = this.dialog.open(m.SessionWarningDialogComponent, {
          width: "500px",
          maxWidth: "95vw",
          minWidth: "280px",
          disableClose: true,
          data: {
            timeRemaining: warningDuration,
            remainingTimeEnd: this.remainingTimeEnd,
          },
        });

        if (this.inactivityTimer) {
          clearTimeout(this.inactivityTimer);
          this.inactivityTimer = null;
        }

        this.dialogRef.afterClosed().subscribe((result: any) => {
          this.dialogRef = null;
          if (result === "continue") {
            this.continueSession();
          } else if (result === "logout") {
            this.handleLogout();
          } else if (result === "expired") {
            this.clearSessionAndReload();
          }
        });
      },
    );
    if (typeof document !== "undefined" && document.hidden) {
      this.hasShownSessionWarning = true;
      return;
    }
  }

  continueSession(): void {
    // Reset the countdown back to full 20 minutes
    this.hasShownSessionWarning = false;
    this.startSessionCountdown();

    // Notify server to extend the session (fire-and-forget)
    this.authService.extendSession().subscribe({
      next: (resp: any) => {
        try {
          const data = resp.response || {};
          const token = data.token;
          const expiresAt = Number(data.expiresAt);
          this.tokenService.updateSessionTimer(data.sessionTimer);
          const remember = !!(
            this.tokenService.getAccessTokenRaw() &&
            this.tokenService.getTokenExpiry()
          );
          if (token) {
            this.tokenService.setAccessToken(token, remember);
            if (expiresAt && Number.isFinite(expiresAt)) {
              this.tokenService.setTokenExpiry(expiresAt, remember);
            }
          }
          this.startSessionCountdown();
        } catch (_e) {
          /* ignore */
        }
      },
      error: (_err) => {
        this.authService.signOut();
        /* ignore - session timer is independent of server */
      },
    });
  }

  handleLogout(): void {
    this.stopSessionCountdown();
    this.stopInactivityTracking();
    this.authService.signOut();
    try {
      this.hideAccessibility();
    } catch (e) {}
    // try { this.alertService.show('Successfully logged out', { type: 'success', duration: 4000 }); } catch (e) { }
    // this.routeToHome();
  }

  stopInactivityTracking(): void {
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }

    // if (typeof window !== "undefined" && this.boundOnUserActivity) {
    //   window.removeEventListener("mousemove", this.boundOnUserActivity);
    //   window.removeEventListener("keydown", this.boundOnUserActivity);
    //   window.removeEventListener("click", this.boundOnUserActivity);
    //   window.removeEventListener("scroll", this.boundOnUserActivity);
    //   window.removeEventListener("touchstart", this.boundOnUserActivity);
    //   this.boundOnUserActivity = null;
    // }

    if (typeof document !== "undefined" && this.boundOnVisibilityChange) {
      document.removeEventListener(
        "visibilitychange",
        this.boundOnVisibilityChange,
      );
      this.boundOnVisibilityChange = null;
    }

    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }

  async getData(): Promise<void> {
    this.showloading = true;
    try {
      const userLoggedData = await this.httpService.getJsonData(
        environment.mainNav,
        "",
      );
      let values: any[] = userLoggedData["response"]?.values || [];
      console.log(values, "Values of Nav")

      // Use boolean flags from mainNav JSON to control visibility:
      // - `hide`: hide the item for everyone
      // - `tinOnly`: only visible for roles containing 'tin'
      // - `teamOnly`: only visible for roles containing 'team' or 'teammember'
      // If no flags are present, item is visible. This makes visibility editable via JSON only.

      const storedRole = String(
        this.secureStorage.get<string>("user_role", true) || "",
      ).toLowerCase();
      const tokenRole = String(
        this.tokenService.getUserProfile()?.role || "",
      ).toLowerCase();
      const role = (storedRole || tokenRole || "").toLowerCase();
      console.log("User role for header visibility:", role, {
        storedRole,
        tokenRole,
      });

      values = values.filter((item) => {
        try {
          console.debug(
            "Checking visibility for item",
            item,
            item.hide,
            item.tinOnly,
            item.teamOnly,
          );
          if (!item) return false;
          if (item.hide === true) return false;

          // tinOnly: explicit allowlist
          if (item.tinOnly === true) {
            return role.includes("tin");
          }

          // teamOnly: explicit allowlist
          if (item.teamOnly === true) {
            return role.includes("team") || role.includes("teammember");
          }

          // default: visible
          return true;
        } catch (e) {
          return true;
        }
      });

      this.headerValues = values;
    } catch (error) {
      console.error("Error fetching data", error);
    }
  }

  clearSessionAndReload(): void {
    let userId = this.tokenService.getUserId();
    this.authService.checkSessionValidity(userId).subscribe({
      next: (resp: any) => {
        try {
          const remainingSessionTime = resp?.response?.user?.sessionTimer;
          if (remainingSessionTime <= 0) {
            // Session is about to expire - show warning
            this.stopSessionCountdown();
            this.stopInactivityTracking();
            this.authService.signOut();
          } else {
            this.tokenService.updateSessionTimer(remainingSessionTime);
            this.startSessionCountdown();
          }
        } catch (error) {
          console.warn("Error parsing session validity response:", error);
        }
      },
      error: (err) => {
        console.error("Session validity check failed:", err);
      },
    });

    try {
      this.hideAccessibility();
    } catch (e) {}
    // show logout toast
    // try { this.alertService.show('Successfully logged out', { type: 'success', duration: 4000 }); } catch (e) { }
    // this.routeToHome();
  }

  private scheduleHeaderHeightUpdate(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (typeof requestAnimationFrame !== "function") {
      this.updateHeaderHeight();
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        this.ngZone.run(() => {
          this.updateHeaderHeight();
        });
      });
    });
  }

  private normalizeRoutePath(route: string): string {
    if (!route) {
      return "/";
    }
    const withLeadingSlash = route.startsWith("/") ? route : `/${route}`;
    const [withoutQuery] = withLeadingSlash.split("?");
    const [withoutFragment] = withoutQuery.split("#");
    let normalized = withoutFragment.replace(/\/{2,}/g, "/");
    while (normalized.length > 1 && normalized.endsWith("/")) {
      normalized = normalized.slice(0, -1);
    }
    return normalized || "/";
  }

  routeToPage(routerLink: any) {
    if (routerLink === "/") {
      this.clearStorage();
    }
    this.router.navigate([routerLink]);
  }

  clearStorage() {
    this.stopSessionCountdown();
    this.stopInactivityTracking();
    this.authService.signOut();
    try {
      this.hideAccessibility();
    } catch (e) {}
    // try { this.alertService.show('Successfully logged out', { type: 'success', duration: 4000 }); } catch (e) { }
  }

  // Collapse the Bootstrap navbar collapse and dismiss mobile offcanvas if open
  closeNavbarCollapse(): void {
    try {
      // Collapse the navbar collapse element if present
      const collapseEl = document.getElementById("navbarNavDropdown");
      if (collapseEl) {
        try {
          (window as any).bootstrap?.Collapse?.getOrCreateInstance(
            collapseEl,
          )?.hide();
        } catch (e) {
          if (collapseEl && collapseEl.classList)
            collapseEl.classList.remove("show");
        }
        // ensure toggler reflects collapsed state
        const toggler = document.querySelector(
          ".navbar-toggler",
        ) as HTMLElement | null;
        if (toggler) toggler.setAttribute("aria-expanded", "false");
      }

      // Dismiss offcanvas if present
      const offcanvasEl = document.getElementById("mobileSidebar");
      if (offcanvasEl) {
        // Try to click the close button if present
        const closeBtn = offcanvasEl.querySelector(
          '[data-bs-dismiss="offcanvas"]',
        ) as HTMLElement | null;
        if (closeBtn) {
          closeBtn.click();
        } else {
          try {
            (window as any).bootstrap?.Offcanvas?.getOrCreateInstance(
              offcanvasEl,
            )?.hide();
          } catch (e) {
            if (offcanvasEl && offcanvasEl.classList) {
              offcanvasEl.classList.remove("show");
            }
            // remove backdrop if any
            const backdrop = document.querySelector(".offcanvas-backdrop");
            if (backdrop && backdrop.parentElement)
              backdrop.parentElement.removeChild(backdrop);
            try {
              if (document && document.body && document.body.classList) {
                document.body.classList.remove("offcanvas-open");
              }
            } catch (err) {
              /* ignore */
            }
          }
        }
      }
    } catch (err) {
      // ignore errors
    }
  }

  isRouteSelected(route?: string | null): boolean {
    if (!route) {
      return false;
    }
    const targetPath = this.normalizeRoutePath(route);
    if (targetPath === "/") {
      return this.selectedPath === "/";
    }
    // exact match or starts with target (sub-route)
    if (
      this.selectedPath === targetPath ||
      this.selectedPath.startsWith(`${targetPath}/`)
    ) {
      return true;
    }

    // additionally, match by top-level segment (e.g., '/taxpayer' matches '/taxpayer/*')
    const getTopSegment = (p: string) => {
      const seg = p.split("/").filter(Boolean)[0];
      return seg ? `/${seg}` : "/";
    };

    const selectedTop = getTopSegment(this.selectedPath);
    const targetTop = getTopSegment(targetPath);

    return selectedTop === targetTop;
  }

  toggleMenu(index: number): void {
    this.activeMenuIndex = this.activeMenuIndex === index ? null : index;
    this.scheduleHeaderHeightUpdate();
  }

  toggleDropdown(): void {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  private updateResponsiveState(): void {
    if (typeof window === "undefined") return;

    this.isPhoneView = window.innerWidth < this.PHONE_VIEW_BREAKPOINT;
  }

  async loadApps(): Promise<void> {
    try {
      const result = await this.httpService.getJsonData(
        "JSONData/apps.json",
        "",
      );
      if (result && result.status === 200 && result.response) {
        this.apps = Array.isArray(result.response)
          ? result.response
          : result.response.apps || [];
        try {
          const profile = this.tokenService?.getUserProfile?.() || {};
          console.log("User profile for app filtering:", profile, this.apps);
          const restricTaxType = [
            "Individual Resident",
            "Individual Non-Resident",
            "Entity Non-Resident",
          ];
          const removeDMTT = restricTaxType.includes(profile.taxType);
          if (removeDMTT) {
            this.apps = (this.apps || []).filter(
              (a: any) => String(a?.id || "").toLowerCase() !== "dmtt",
            );
          }
        } catch (e) {
          // ignore
        }
      }
    } catch (e) {
      console.warn("Failed to load apps.json", e);
      this.apps = [];
    }
  }

  toggleAppPanel(event?: Event): void {
    if (event) event.stopPropagation();
    this.isAppPanelVisible = !this.isAppPanelVisible;
    if (this.isAppPanelVisible) {
      this.isDropdownVisible = false;
      this.viewAccessibility = false;
    }
  }

  openApp(app: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
      try {
        (event as any).preventDefault?.();
      } catch (e) {
        /* ignore */
      }
    }
    if (!app || (!app.url && !app.baseUrl)) return;
    try {
      const envAny: any = environment as any;
      const rawUrl = (app.url || "").toString();
      let action = rawUrl;
      console.log("Opening app", app, {
        rawUrl,
        envAnyBaseUrl: app.baseUrl ? envAny[app.baseUrl] : undefined,
      });

      if (
        app.baseUrl &&
        envAny &&
        typeof envAny[app.baseUrl] === "string" &&
        envAny[app.baseUrl]
      ) {
        const base = String(envAny[app.baseUrl] || "").replace(/\/$/, "");
        if (rawUrl) {
          const path = rawUrl.startsWith("/") ? rawUrl : "/" + rawUrl;
          action = base + path;
        } else {
          action = base;
        }
      }

      const target = app.target || "_blank";

      if (isPlatformBrowser(this.platformId)) {
        try {
          const isDmttTarget =
            String(app?.baseUrl || "").toLowerCase() === "dmttdashboardurl";
          if (isDmttTarget) {
            const userObj: any = this.tokenService?.getUserData?.() || {};
            const userProfile: any =
              this.tokenService?.getUserProfile?.() || {};
            const dmttPayload = {
              token: this.tokenService?.getAccessToken?.() || "",
              profile: {
                binNumber:
                  userObj?.binNumber ||
                  userObj?.userId ||
                  userObj?.TIN ||
                  userObj?.tin ||
                  userProfile?.tin ||
                  userProfile?.id ||
                  "",
                email: userObj?.email || userProfile?.email || null,
                persona:
                  userObj?.persona ||
                  userObj?.profiles ||
                  userObj?.role ||
                  userProfile?.role ||
                  userProfile?.profile ||
                  [],
                tinNumber:
                  userObj?.tinNumber ||
                  userObj?.TIN ||
                  userObj?.tin ||
                  userProfile?.tin ||
                  null,
                taxType: userObj?.taxType || userObj?.tax_type || null,
                firstName: userObj?.firstName || userObj?.firstname || null,
                lastName: userObj?.lastName || userObj?.lastname || null,
                mobileNumber:
                  userObj?.mobileNumber ||
                  userObj?.mobile ||
                  userObj?.phone ||
                  userProfile?.phone ||
                  null,
                isFirstTimeLogin: userObj?.isFirstTimeLogin || null,
                applicationId:
                  userObj?.applicationId ||
                  userObj?.applicationid ||
                  userObj?.userId ||
                  "",
                registeredName:
                  userObj?.registeredName || userObj?.registered_name || "",
              },
            };

            const encryptedPayload =
              this.encryptionService.encrypt(dmttPayload);
            const sep = action.indexOf("?") !== -1 ? "&" : "?";
            const dmttUrl = `${action}${sep}dmtt_token=${encodeURIComponent(encryptedPayload)}`;

            if (target === "_self" || target === "self") {
              try {
                window.location.href = dmttUrl;
              } catch (e) {
                console.warn("Navigation failed", e);
              }
            } else {
              try {
                window.open(dmttUrl, target);
              } catch (e) {
                console.warn("Open external failed", e);
              }
            }
            this.isAppPanelVisible = false;
            return;
          }

          // const isOtbTarget =
          //           String(app?.id || '').toLowerCase() === 'otb' ||
          //           String(app?.baseUrl || '').toLowerCase() === 'otbdashboardurl';

          //         if (isOtbTarget && app?.autoLogin) {
          //           let applicationid = '';
          //           let token = '';
          //           let bin = '';

          // try {
          //             const ud: any = this.tokenService?.getUserData?.() || {};
          //             const up: any = this.tokenService?.getUserProfile?.() || {};

          //           const sep = action.indexOf('?') !== -1 ? '&' : '?';
          //           const otbUrl = params.length ? `${action}${sep}${params.join('&')}` : action;

          //             applicationid = ud.userId || ud.applicationId || ud.applicationid || up.userId || up.applicationId || '';

          //   // logged BIN
          //             bin = ud.binNumber || ud.bin || up.binNumber || up.bin || '';
          //           } catch (e) { }

          //           try { token = this.tokenService?.getAccessToken?.() || ''; } catch (e) { }

          //  const encryptedToken = token ? this.encryptionService.encrypt(token) : '';
          //           const encryptedAppId = applicationid ? this.encryptionService.encrypt(applicationid) : '';

          //           const params: string[] = [];
          //           if (encryptedToken) params.push(`token=${encodeURIComponent(encryptedToken)}`);
          //           if (encryptedAppId)

          // params.push(`applicationid=${encodeURIComponent(encryptedAppId)}`);
          // // if (token) params.push(`token=${encodeURIComponent(token)}`);
          // // if (applicationid) params.push(`applicationid=${encodeURIComponent(applicationid)}`);
          //           // BIN param from apps.json config
          //           const includeBin = app?.includeBin === true;
          //           const binKey = String(app?.binParamKey || 'bin');
          //           if (includeBin && bin) params.push(`${encodeURIComponent(binKey)}=${encodeURIComponent(String(bin))}`);

          //           const sep = action.indexOf('?') !== -1 ? '&' : '?';
          //           const otbUrl = params.length ? `${action}${sep}${params.join('&')}` : action;

          //           if (target === '_self' || target === 'self') {
          //             try { window.location.href = otbUrl; } catch (e) { console.warn('Navigation failed', e); }

          // } else {
          //             try { window.open(otbUrl, target); } catch (e) { console.warn('Open external failed', e); }
          //           }

          //           this.isAppPanelVisible = false;
          //           return;
          //         }
          // detect OTB correctly (your previous compare had case issue)
          const isOtbTarget =
            String(app?.id || "").toLowerCase() === "otb" ||
            String(app?.baseUrl || "").toLowerCase() === "otbdashboardurl";

          if (isOtbTarget && app?.autoLogin) {
            let applicationid = "";
            let token = "";
            let bin = "";

            try {
              const ud: any = this.tokenService?.getUserData?.() || {};
              const up: any = this.tokenService?.getUserProfile?.() || {};

              applicationid =
                ud.userId ||
                ud.applicationId ||
                ud.applicationid ||
                up.id ||
                up.userId ||
                up.applicationId ||
                "";

              // Do NOT fetch BIN; we don't want OTB to route to /dashboard/bin/{bin}
            } catch {}

            try {
              token = this.tokenService?.getAccessToken?.() || "";
            } catch {}

            // SAFETY: if token still looks encrypted (has ":" and no ".") then decrypt it once
            try {
              if (token && token.includes(":") && !token.includes(".")) {
                const dec = this.encryptionService.decrypt(token);
                if (typeof dec === "string" && dec.trim()) token = dec.trim();
              }
            } catch {}

            // Do NOT encrypt token/applicationid in URL
            const params: string[] = [];
            if (token) params.push(`token=${encodeURIComponent(token)}`);
            if (applicationid)
              params.push(`applicationid=${encodeURIComponent(applicationid)}`);

            // '&' not '&amp;'
            const sep = action.includes("?") ? "&" : "?";
            const otbUrl = params.length
              ? `${action}${sep}${params.join("&")}`
              : action;

            try {
              window.open(otbUrl, "_blank", "noopener,noreferrer");
            } catch (e) {
              console.warn("OTB open failed", e);
            }
            this.isAppPanelVisible = false;
            return;
          }

          let applicationid = "";
          let token = "";
          try {
            const ud: any = this.tokenService?.getUserData?.();
            if (ud) applicationid = ud.userId;
          } catch (e) {}
          try {
            token = this.tokenService?.getAccessToken?.() || "";
          } catch (e) {}

          const encryptedToken = token
            ? this.encryptionService.encrypt(token)
            : "";
          const encryptedAppId = applicationid
            ? this.encryptionService.encrypt(applicationid)
            : "";

          const params: string[] = [];
          const nonce = this.encryptionService.encrypt(crypto.randomUUID());
          // const nonce = crypto.randomUUID();
          params.push(`nonce=${encodeURIComponent(nonce)}`);

          document.cookie = `app_nonce=${nonce};path=/;max-age=60;secure;samesite=lax;domain=.onetaxbahamas.gov.bs`;
          if (encryptedToken)
            params.push(`token=${encodeURIComponent(encryptedToken)}`);
          if (encryptedAppId)
            params.push(`applicationid=${encodeURIComponent(encryptedAppId)}`);

          const sep = action.indexOf("?") !== -1 ? "&" : "?";
          const urlWithParams = params.length
            ? `${action}${sep}${params.join("&")}`
            : action;

          const isTraRoute = /\/taxpayer-registration(\/|$)/.test(action);
          if (isTraRoute) {
            if (target === "_self" || target === "self") {
              try {
                window.location.href = urlWithParams;
              } catch (e) {
                console.warn("Navigation failed", e);
              }
            } else {
              try {
                window.open(urlWithParams, target);
              } catch (e) {
                console.warn("Open external failed", e);
              }
            }
            this.isAppPanelVisible = false;
            return;
          }

          this.isAppPanelVisible = false;
          return;
        } catch (e) {
          console.warn(
            "Auto-login navigation failed, falling back to open:",
            e,
          );
        }
      }

      if (this.isExternalUrl(action)) {
        try {
          window.open(action, target);
        } catch (e) {
          console.warn("Open external failed", e);
        }
      } else {
        try {
          this.router.navigateByUrl(action);
        } catch (e) {
          console.warn("Navigation to app failed", e);
        }
      }
    } catch (e) {
      console.warn("openApp failed", e);
    }
    this.isAppPanelVisible = false;
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;

    // Close search dropdown and mobile search only when clicking outside search elements
    try {
      const clickedInsideSearch =
        !!target.closest(".search-box") ||
        !!target.closest(".search-dropdown") ||
        !!target.closest(".mobileSearch");

      // Detect clicks that toggle accordions (Bootstrap or custom) so that opening an accordion also closes the search
      const clickedAccordionToggle =
        !!target.closest(".accordion-button") ||
        !!target.closest('[data-bs-toggle="collapse"]') ||
        !!target.closest(".accordion-toggle") ||
        !!target.closest("mat-expansion-panel-header");
      const clickedAccordionContent =
        !!target.closest(".accordion-collapse") ||
        !!target.closest(".accordion-body") ||
        !!target.closest("mat-expansion-panel") ||
        !!target.closest(".mat-expansion-panel-body");

      if (!clickedInsideSearch) {
        this.showDropdown = false;
        if (this.displaySearch) {
          this.displaySearch = false;
        }
      } else if (
        clickedInsideSearch &&
        (clickedAccordionToggle || clickedAccordionContent)
      ) {
        // If user clicked an accordion toggle inside the search results, close the search dropdown
        this.showDropdown = false;
        if (this.displaySearch) this.displaySearch = false;
      }
    } catch (e) {
      this.showDropdown = false;
      if (this.displaySearch) this.displaySearch = false;
    }

    // Close accessibility panel when clicking outside it
    try {
      const clickedInsideAccess =
        !!target.closest(".accessibility-section") ||
        !!target.closest(".access") ||
        !!target.closest(".mobile-accessibility-action");
      if (!clickedInsideAccess) {
        this.viewAccessibility = false;
      }
    } catch (e) {
      this.viewAccessibility = false;
    }

    // Close apps panel when clicking outside it
    try {
      const clickedInsideApp =
        !!target.closest(".app-switcher") || !!target.closest(".apps-panel");
      if (!clickedInsideApp) {
        this.isAppPanelVisible = false;
      }
    } catch (e) {
      this.isAppPanelVisible = false;
    }

    // Toggle profile dropdown only if click was outside .profile-box
    try {
      const clickedInsideProfile = !!target.closest(".profile-box");
      if (!clickedInsideProfile) {
        this.isDropdownVisible = false;
      }
    } catch (e) {
      this.isDropdownVisible = false;
    }
  }
  onDropdownLinkNavigate(): void {
    this.closeSearchDropdown({ resetInput: true });
  }

  private closeSearchDropdown(options?: {
    blur?: boolean;
    hideOverlay?: boolean;
    resetInput?: boolean;
  }): void {
    const {
      blur = true,
      hideOverlay = true,
      resetInput = false,
    } = options ?? {};

    this.showDropdown = false;
    if (hideOverlay) {
      this.displaySearch = false;
    }

    if (resetInput) {
      this.searchText = "";
      this.searchInput = "";
    }

    if (blur && isPlatformBrowser(this.platformId)) {
      const desktopInput = document.querySelector(
        ".search-box .search",
      ) as HTMLInputElement | null;
      desktopInput?.blur();

      const mobileInput = document.querySelector(
        ".mobileSearch .search",
      ) as HTMLInputElement | null;
      mobileInput?.blur();
    }
  }

  resultHref(item: any): string {
    const route = this.normalizeRouteTarget(item?.route);
    if (!route) {
      return "#";
    }
    const fragment =
      typeof item?.fragment === "string" && item.fragment.trim()
        ? `#${item.fragment.trim()}`
        : "";
    return `${route}${fragment}`;
  }

  private normalizeRouteTarget(route: unknown): string {
    if (typeof route !== "string") {
      return "";
    }
    const trimmed = route.trim();
    if (!trimmed) {
      return "";
    }
    if (/^(https?:|mailto:|tel:)/i.test(trimmed)) {
      return trimmed;
    }
    return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  }

  goToSearchResult(item: any, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    if (!item) {
      return;
    }

    const targetRoute = this.normalizeRouteTarget(item.route);
    const fragment =
      typeof item?.fragment === "string" && item.fragment.trim()
        ? item.fragment.trim()
        : "";
    const searchTerm =
      typeof item?.searchTerm === "string"
        ? item.searchTerm.trim()
        : typeof this.searchInput === "string"
          ? this.searchInput.trim()
          : "";

    this.closeSearchDropdown({ resetInput: true });

    if (!targetRoute) {
      return;
    }

    if (this.isExternalUrl(targetRoute)) {
      const href = fragment ? `${targetRoute}#${fragment}` : targetRoute;
      window.open(href, "_blank");
      return;
    }

    // Build an UrlTree so Angular router knows about the fragment and query param explicitly
    try {
      const urlTree = this.router.parseUrl(targetRoute || "/");
      if (fragment) {
        urlTree.fragment = fragment;
      }

      // determine menu param: prefer explicit contentId, else derive from route last segment
      let menuParam: string | null = null;
      if (item && (item.contentId || item.contentId === 0)) {
        menuParam = String(item.contentId);
      }
      if (!menuParam) {
        const segs = (targetRoute || "").split("/").filter(Boolean);
        if (segs.length) {
          menuParam = segs[segs.length - 1];
        }
      }

      if (menuParam) {
        const navigationExtras: any = { fragment };
        navigationExtras.queryParams = {
          ...(navigationExtras.queryParams || {}),
          menu: menuParam,
        };
        this.router
          .navigateByUrl(targetRoute, navigationExtras)
          .then(() => {
            if (fragment) {
              setTimeout(
                () =>
                  scrollToFragmentId(fragment, this.platformId, {
                    highlightText: searchTerm || item.label || "",
                  }),
                350,
              );
              setTimeout(
                () =>
                  scrollToFragmentId(fragment, this.platformId, {
                    highlightText: searchTerm || item.label || "",
                  }),
                1200,
              );
            } else if (searchTerm) {
              // No fragment but we have search term - highlight on page
              setTimeout(
                () => highlightTextOnPage(searchTerm, this.platformId),
                350,
              );
              setTimeout(
                () => highlightTextOnPage(searchTerm, this.platformId),
                1200,
              );
            }
          })
          .catch((err) =>
            console.error("Navigation failed for search result:", err, item),
          );
      } else {
        this.router
          .navigateByUrl(urlTree)
          .then(() => {
            if (fragment) {
              setTimeout(
                () =>
                  scrollToFragmentId(fragment, this.platformId, {
                    highlightText: searchTerm || item.label || "",
                  }),
                350,
              );
              setTimeout(
                () =>
                  scrollToFragmentId(fragment, this.platformId, {
                    highlightText: searchTerm || item.label || "",
                  }),
                1200,
              );
            } else if (searchTerm) {
              // No fragment but we have search term - highlight on page
              setTimeout(
                () => highlightTextOnPage(searchTerm, this.platformId),
                350,
              );
              setTimeout(
                () => highlightTextOnPage(searchTerm, this.platformId),
                1200,
              );
            }
          })
          .catch((err) =>
            console.error("Navigation failed for search result:", err, item),
          );
      }
    } catch (err) {
      // Fallback: simple navigation if UrlTree build fails — append menu param if we can
      const urlBase = fragment ? `${targetRoute}#${fragment}` : targetRoute;
      let fallbackUrl = urlBase;
      if (item && (item.contentId || item.contentId === 0)) {
        const connector = fallbackUrl.includes("?") ? "&" : "?";
        fallbackUrl = `${fallbackUrl}${connector}menu=${encodeURIComponent(String(item.contentId))}`;
      }
      this.router
        .navigateByUrl(fallbackUrl)
        .then(() => {
          if (fragment) {
            setTimeout(
              () =>
                scrollToFragmentId(fragment, this.platformId, {
                  highlightText: searchTerm || item.label || "",
                }),
              350,
            );
          } else if (searchTerm) {
            // No fragment but we have search term - highlight on page
            setTimeout(
              () => highlightTextOnPage(searchTerm, this.platformId),
              350,
            );
          }
        })
        .catch((e) => console.error("Fallback navigation failed:", e, item));
    }
  }

  @HostListener("window:blur")
  handleWindowBlur(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    this.scheduleHeaderHeightUpdate();
  }

  @HostListener("window:focus")
  handleWindowFocus(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    this.scheduleHeaderHeightUpdate();
  }
  private safePreventDefault(event: Event | KeyboardEvent): void {
    try {
      if (event && "cancelable" in event && (event as any).cancelable === false)
        return;
      if (typeof (event as any).preventDefault === "function")
        (event as any).preventDefault();
    } catch (e) {
      console.warn("preventDefault failed", e);
    }
  }
  private navigateToNextPage(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    // console.log('navigateToNextPage called, currentIndex:', this.currentHistoryIndex, 'length:', this.navigationHistory.length, 'history:', this.navigationHistory);
    try {
      if (this.currentHistoryIndex < this.navigationHistory.length - 1) {
        this.currentHistoryIndex++;
        // console.log('Navigating to:', this.navigationHistory[this.currentHistoryIndex]);
        this.isNavigatingViaShortcut = true;
        this.router
          .navigateByUrl(this.navigationHistory[this.currentHistoryIndex])
          .then(() => {
            this.isNavigatingViaShortcut = false;
          });
      } else {
        // console.log('No next page in history');
      }
    } catch (e) {
      console.warn("navigateToNextPage failed", e);
      this.isNavigatingViaShortcut = false;
    }
  }

  private navigateToPreviousPage(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    // console.log('navigateToPreviousPage called, currentIndex:', this.currentHistoryIndex, 'length:', this.navigationHistory.length, 'history:', this.navigationHistory);
    try {
      if (this.currentHistoryIndex > 0) {
        this.currentHistoryIndex--;
        // console.log('Navigating to:', this.navigationHistory[this.currentHistoryIndex]);
        this.isNavigatingViaShortcut = true;
        this.router
          .navigateByUrl(this.navigationHistory[this.currentHistoryIndex])
          .then(() => {
            this.isNavigatingViaShortcut = false;
          });
      } else {
        // console.log('No previous page in history');
      }
    } catch (e) {
      console.warn("navigateToPreviousPage failed", e);
      this.isNavigatingViaShortcut = false;
    }
  }

  // @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // console.log(event, "keyboardEvents")
    // Open Accessibility: Alt+A (Windows/Mac Option+A)
    if (this.keyboardService.isAltShortcut(event, "a", "KeyA")) {
      this.safePreventDefault(event);
      this.openAccessibility();
    }

    // Focus on search in Header: Alt+S or Alt+/ or Alt+?
    if (
      this.keyboardService.isAltShortcut(event, "s", "KeyS") ||
      this.keyboardService.isAltShortcut(event, "/", "Slash") ||
      this.keyboardService.isAltShortcut(event, "?", "Slash")
    ) {
      this.safePreventDefault(event);
      const searchBox =
        document.querySelector<HTMLInputElement>(".search-box input");
      if (searchBox) {
        searchBox.focus();
      }
    }

    // Close accessibility panel or dropdown on Escape key
    if (event.key === "Escape") {
      this.safePreventDefault(event);
      if (this.viewAccessibility) {
        this.hideAccessibility();
      } else if (this.isDropdownVisible) {
        this.isDropdownVisible = false;
      } else if (this.displaySearch) {
        this.closeMobileSearch();
      }
    }
    const keyLc = event.key ? event.key.toLocaleLowerCase() : "";
    const code = event.code;

    // Logout shortcut: Ctrl+Shift+L (Windows/Linux) or Cmd+Shift+L (Mac)
    if (
      this.keyboardService.isCmdCtrl(event) &&
      event.shiftKey &&
      (keyLc === "l" || code === "KeyL")
    ) {
      this.authService.signOut();
      // this.router.navigate(['/']);
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (event.shiftKey && (keyLc === "space" || code === "Space")) {
      window.scrollBy({
        top: -window.innerHeight,
        left: 0,
        behavior: "smooth",
      });
    } else if (keyLc === "space" || code === "Space") {
      window.scrollBy({
        top: window.innerHeight,
        left: 0,
        behavior: "smooth",
      });
    }

    // Scroll Bottom/Top
    // Alt+F -> Bottom, Alt+G -> Top
    // Also ArrowRight/End -> Bottom, ArrowLeft/Home -> Top
    // Also Cmd+Opt+ArrowRight/Left (handled by isAltShortcut if we pass ArrowRight/Left)

    const isAltRight = this.keyboardService.isAltShortcut(
      event,
      "arrowright",
      "ArrowRight",
    );
    const isAltLeft = this.keyboardService.isAltShortcut(
      event,
      "arrowleft",
      "ArrowLeft",
    );
    const isAltF = this.keyboardService.isAltShortcut(event, "f", "KeyF");
    const isAltG = this.keyboardService.isAltShortcut(event, "g", "KeyG");

    if (
      keyLc === "arrowright" ||
      code === "ArrowRight" ||
      keyLc === "end" ||
      code === "End" ||
      (isAltF && event.altKey) ||
      isAltRight
    ) {
      window.scrollTo({
        top: document.body.scrollHeight,
        left: 0,
        behavior: "smooth",
      });
    } else if (
      keyLc === "arrowleft" ||
      code === "ArrowLeft" ||
      keyLc === "home" ||
      code === "Home" ||
      (isAltG && event.altKey) ||
      isAltLeft
    ) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }

    // Navigate to contact information: Alt+C
    if (
      this.keyboardService.isAltShortcut(event, "c", "KeyC") &&
      event.altKey
    ) {
      this.router.navigate(["/help/contact-information"]);
    }
    // Navigate to Terms of Use: Alt+T
    if (this.keyboardService.isAltShortcut(event, "t", "KeyT")) {
      this.router.navigate(["/terms-of-use"]);
    }
    // Navigate to Privacy Policy: Alt+L
    if (this.keyboardService.isAltShortcut(event, "l", "KeyL")) {
      this.router.navigate(["/privacy-policy"]);
    }
    // Navigate to Help: Alt+H
    if (this.keyboardService.isAltShortcut(event, "h", "KeyH")) {
      this.router.navigate(["/help"]);
    }
    // Navigate to Home: Alt+1
    if (this.keyboardService.isAltShortcut(event, "1", "Digit1")) {
      this.router.navigate(["/"]);
    }
    // Navigate to Profile: Alt+U
    if (this.keyboardService.isAltShortcut(event, "u", "KeyU")) {
      this.router.navigate(["/account/profile"]);
    }

    // Toggle full screen: Ctrl+Shift+F (Windows/Linux) or Cmd+Ctrl+F (macOS)
    const isCmdCtrlF =
      this.keyboardService.isCmdCtrl(event) &&
      (keyLc === "f" || code === "KeyF");
    const isCtrlShiftF =
      event.ctrlKey && event.shiftKey && (keyLc === "f" || code === "KeyF");
    if (isCtrlShiftF || isCmdCtrlF) {
      this.safePreventDefault(event);
      this.toggleFullScreen();
    }

    // Navigate to Next / Previous page: Alt+N / Alt+P
    if (this.keyboardService.isAltShortcut(event, "n", "KeyN")) {
      // console.log('Alt+N detected');
      this.safePreventDefault(event);
      this.navigateToNextPage();
      return;
    }
    if (this.keyboardService.isAltShortcut(event, "p", "KeyP")) {
      // console.log('Alt+P detected');
      this.safePreventDefault(event);
      this.navigateToPreviousPage();
      return;
    }

    // Insert + H: handle entirely within this function (transient insertPressed state)
    const isInsertKey = keyLc === "insert" || code === "Insert";
    const isHKey = keyLc === "h" || code === "KeyH";

    // Mac-friendly listen toggle: Cmd+Ctrl+H (alternative to Insert+H on Mac)
    const isCmdCtrlH =
      this.keyboardService.isCmdCtrl(event) &&
      (keyLc === "h" || code === "KeyH");

    if (isCmdCtrlH) {
      // consume the shortcut similar to Insert+H
      if (this.insertTimeout) {
        window.clearTimeout(this.insertTimeout);
        this.insertTimeout = null;
      }
      this.insertPressed = false;
      this.safePreventDefault(event);
      const currently = localStorage.getItem("accessibility-listen") === "true";
      if (currently) {
        window.speechSynthesis.cancel();
        localStorage.setItem("accessibility-listen", "false");
        // console.debug('[Header] Cmd+Ctrl+H -> listen OFF');
      } else {
        localStorage.setItem("accessibility-listen", "true");
        resetHeaderSpokenState();
        readEntirePage();
        // console.debug('[Header] Cmd+Ctrl+H -> listen ON');
      }
      try {
        this.bus.emit("accessibility-listen-toggled");
      } catch (e) {}
      return;
    }

    if (isInsertKey) {
      // mark insert pressed for a short window (e.g., 1.5s)
      this.insertPressed = true;
      if (this.insertTimeout) {
        window.clearTimeout(this.insertTimeout);
      }
      this.insertTimeout = window.setTimeout(() => {
        this.insertPressed = false;
        this.insertTimeout = null;
      }, 1500);
      // console.debug('[Header] Insert pressed — awaiting next key');
    }

    if (
      isHKey &&
      (this.insertPressed ||
        (event.getModifierState && event.getModifierState("Insert")))
    ) {
      // consume the shortcut
      if (this.insertTimeout) {
        window.clearTimeout(this.insertTimeout);
        this.insertTimeout = null;
      }
      this.insertPressed = false;
      this.safePreventDefault(event);
      const currently = localStorage.getItem("accessibility-listen") === "true";
      if (currently) {
        window.speechSynthesis.cancel();
        localStorage.setItem("accessibility-listen", "false");
        // console.debug('[Header] Insert+H -> listen OFF');
      } else {
        localStorage.setItem("accessibility-listen", "true");
        resetHeaderSpokenState();
        readEntirePage();
        // console.debug('[Header] Insert+H -> listen ON');
      }
      try {
        this.bus.emit("accessibility-listen-toggled");
      } catch (e) {}
      return;
    }
  }

  private toggleFullScreen(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const doc: any = document as any;
    const docEl: any = document.documentElement as any;

    const isFull = !!(
      doc.fullscreenElement ||
      doc.webkitFullscreenElement ||
      doc.mozFullScreenElement ||
      doc.msFullscreenElement
    );

    if (isFull) {
      const exit =
        doc.exitFullscreen ||
        doc.webkitExitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.msExitFullscreen;
      if (exit) {
        exit
          .call(doc)
          .catch((e: any) => console.warn("Exit fullscreen failed", e));
      }
    } else {
      const request =
        docEl.requestFullscreen ||
        docEl.webkitRequestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.msRequestFullscreen;
      if (request) {
        request
          .call(docEl)
          .catch((e: any) => console.warn("Request fullscreen failed", e));
      }
    }
  }

  // Clipboard / contextmenu / drop prevention handlers for search inputs
  private _clipboardBlockTimeout: any = null;

  preventPaste(evt: ClipboardEvent | any) {
    try {
      evt.preventDefault();
    } catch (e) {
      /* ignore */
    }
    this.showBlockedClipboardMessage();
  }

  preventCopy(evt: ClipboardEvent | any) {
    try {
      evt.preventDefault();
    } catch (e) {
      /* ignore */
    }
    this.showBlockedClipboardMessage();
  }

  preventCut(evt: ClipboardEvent | any) {
    try {
      evt.preventDefault();
    } catch (e) {
      /* ignore */
    }
    this.showBlockedClipboardMessage();
  }

  preventContext(evt: Event | any) {
    try {
      evt.preventDefault();
    } catch (e) {
      /* ignore */
    }
    this.showBlockedClipboardMessage();
  }

  preventDrop(evt: DragEvent | any) {
    try {
      evt.preventDefault();
    } catch (e) {
      /* ignore */
    }
    this.showBlockedClipboardMessage();
  }

  private showBlockedClipboardMessage() {
    if (this._clipboardBlockTimeout) return;
    this._clipboardBlockTimeout = setTimeout(() => {
      this._clipboardBlockTimeout = null;
    }, 1500);
    try {
      this.alertService.show(
        "For security reasons this field does not allow copy or paste.",
        { type: "info", duration: 3000 },
      );
    } catch (e) {
      // console.info('Clipboard action blocked');
    }
  }

  maskBinNumber(bin: string): string {
    if (!bin) return "";
    const replacingWithStars = bin.replace(/\D/g, "");
    const last3 = replacingWithStars.slice(-3);
    return "#XXXXXX" + last3;
  }
}
